import { IColor } from '../ColorModal';
import {
  BottomContainer,
  Container,
  Row,
  ColorCode,
  Title,
  ColorCollection,
  imageStyle,
} from './ColorCard.styled';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { getContrastingLabelColor } from 'utils/colorUtils';
import Tooltip from 'components/Tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import { formatPrice } from './helpers';
import { getColorBackground } from '../helpers';
import { useCurrencySymbol } from 'utils/hooks/useFormatMoney';
import {
  AdaptiveImage,
  AdaptiveImageType,
} from 'components/AdaptiveImage/AdaptiveImage';

interface IColorCardProps {
  isSelected: boolean;
  color: IColor;
  handleChooseColor: (color: IColor) => void;
}

const ColorCard = ({
  isSelected,
  color,
  handleChooseColor,
}: IColorCardProps) => {
  const { t } = useTranslation();

  const { currency } = useSelector(
    (state: IRootReducerState) => state.shoppingCartInfo
  );

  const currencySymbol = useCurrencySymbol(currency);
  const { darkMode } = useSelector(
    (state: IRootReducerState) => state.commonInfo
  );

  const bgColor = getColorBackground(color, darkMode);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleChooseColor(color);
    }
  };

  return (
    <Tooltip content={formatPrice(color.additional_price, t, currencySymbol)}>
      <Container
        isSelected={isSelected}
        bgColor={bgColor}
        onClick={() => handleChooseColor(color)}
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        {color.image && (
          <AdaptiveImage
            imageUrl={color.image}
            type={AdaptiveImageType.COLOR}
            imageStyle={imageStyle}
            onClick={() => handleChooseColor(color)}
          />
        )}
        <BottomContainer>
          <Title color={getContrastingLabelColor(bgColor)}>{color.name}</Title>
          <Row>
            <ColorCode color={getContrastingLabelColor(bgColor)}>
              {color.code ? color.code : ''}
            </ColorCode>
            <ColorCollection color={getContrastingLabelColor(bgColor)}>
              {color.collection ? color.collection : ''}
            </ColorCollection>
          </Row>
        </BottomContainer>
      </Container>
    </Tooltip>
  );
};

export default ColorCard;
